import { render, staticRenderFns } from "./CardBankrollReduction.vue?vue&type=template&id=33235556"
import script from "./CardBankrollReduction.vue?vue&type=script&lang=js"
export * from "./CardBankrollReduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports